import React, { useEffect } from "react";
import { headChat } from "../../assets/image";
import Services from "./Services";
import { getServicesList } from "../../redux/serviceRequest/slice";
import { useDispatch, useSelector } from "react-redux";
import RippleLoader from "../../commons/RippleLoader";

const ServiceRequest = () => {
  const dispatch = useDispatch();
  const getCompanyID = sessionStorage.getItem("companyID");

  // Selector
  const serviceSettingList = useSelector(
    (store) => store?.serviceRequestData?.getServicesListStatus?.data
  );
  const serviceSettingLoading = useSelector(
    (store) => store?.serviceRequestData?.loading
  );

  useEffect(() => {
    if (getCompanyID) {
      dispatch(getServicesList(getCompanyID));
    }
  }, [dispatch, getCompanyID]);

  return (
    <div className="space-y-5">
      <div className="flex items-center space-x-5 border-b-2 border-secondary_grey pb-7">
        <img src={headChat} alt="img" />
        <p className="text-4xl font-ebGaramond">Our Services</p>
      </div>
      <div className="bg-white rounded-md overflow-hidden">
        {serviceSettingLoading ? (
          <RippleLoader />
        ) : (
          <>
            {serviceSettingList?.map((element, index) => {
              return (
                element.status === "active" && (
                  <Services element={element} key={index} />
                )
              );
            })}
          </>
        )}
      </div>
    </div>
  );
};

export default ServiceRequest;
